<div class="ps-flex-container-col" style="padding: 12px">
  <h3>{{'contacts.createConnection.createConnection' | translate}}</h3>

  <mat-form-field>
    <mat-label>{{'contacts.createConnection.type' | translate}}</mat-label>
    <mat-select [(ngModel)]="connection.typeId" multiple="false">
      <mat-option *ngFor="let type of connectionTypes$ | async" [value]="type.OBJECT_ID">
        <img [src]="type.ICON_URL"/>
        {{type.NAME}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createConnection.text' | translate}}</mat-label>
    <input matInput [(ngModel)]="connection.text">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createConnection.info' | translate}}</mat-label>
    <input matInput [(ngModel)]="connection.info">
  </mat-form-field>
  <div style="display: flex; justify-content: end">
    <button mat-button color="accent" matTooltip="{{'contacts.createConnection.discard' | translate}}"
            (click)="dismiss()">
      {{'contacts.createConnection.discard' | translate}}
    </button>
    <button mat-button color="accent" matTooltip="{{'contacts.createConnection.saveConnection' | translate}}"
            (click)="save()">
      {{'contacts.createConnection.save' | translate}}
    </button>
  </div>
</div>
